import { Invoice } from "./Invoice";
import { Order } from "./Order";
export function InvoiceOrder() {
  this.InvoiceOrderId = {
    fieldName: 'invoice_order_id',
    content: ''
  };
  this.InvoiceOrderInvoice = {
    fieldName: 'invoice',
    model: Invoice,
    content: ''
  };
  this.InvoiceOrderOrder = {
    fieldName: 'order',
    model: Order,
    content: ''
  };
}